import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZuperCardComponent } from './zuper-card.component';

@NgModule({
    declarations: [
        ZuperCardComponent
    ],
    imports     : [
        CommonModule
    ],
    exports     : [
        ZuperCardComponent
    ]
})
export class ZuperCardModule
{
}
